import type React from 'react'
import { Box, Container } from '@chakra-ui/react'
import { ICategoryWithProducts } from '@/features/brand-menu'
import StaticBar from '../static-bar'

interface CategoriesSectionProps {
  catalogRef: React.RefObject<HTMLDivElement | null>
  categories: ICategoryWithProducts[]
}

const CategoriesSection = ({
  catalogRef,
}: CategoriesSectionProps) => (
  <Box pb={{ base: 4, lg: 0 }} zIndex={10}>
    <div ref={catalogRef}>
      <Container zIndex={1}>
        <StaticBar />
      </Container>
    </div>
  </Box>
)

export default CategoriesSection
